import { ChangeDetectionStrategy, Component } from "@angular/core";
import { HomeMetric, SystemActivity } from "../../../models/home";
import { UxError } from "../../../models/ux-error.model";
import { HomeInteractionStateService } from "../../../services/home-ia/home-interaction-state.service";
import { SseState } from "../../../services/home-ia/home-stream.service";
import { LanguageService } from "../../../services/language/language.service";
import {
  ALL_DECISIONS_PAGE,
  BLOCKED_DECISIONS_PAGE,
  BLOCKED_DETAIL,
  BLOCKED_HERO,
  DISABLED_DETAIL,
  DISABLED_HERO,
  EMPTY_DATES_SUMMARY,
  EXECUTABLE_DETAIL,
  FORM_DETAIL,
  LOW_CONFIDENCE_DETAIL,
  LOW_CONFIDENCE_HERO,
  READY_HERO,
  buildActivity,
  buildDatesSummary,
  buildMetrics,
  buildPulse,
  buildSummary
} from "./home-qa-harness.fixtures";

@Component({
  selector: "app-home-qa-harness",
  templateUrl: "./home-qa-harness.component.html",
  styleUrls: ["./home-qa-harness.component.scss"],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeQaHarnessComponent {
  readonly pulse = buildPulse();
  readonly summary = buildSummary();
  readonly datesSummary = buildDatesSummary();
  readonly activity = buildActivity()[0];
  readonly activityHistory = buildActivity();
  readonly metrics = buildMetrics();
  readonly readyHero = READY_HERO;
  readonly blockedHero = BLOCKED_HERO;
  readonly disabledHero = DISABLED_HERO;
  readonly feedbackHero = LOW_CONFIDENCE_HERO;
  readonly allDecisionsPage = ALL_DECISIONS_PAGE;
  readonly blockedDecisionsPage = BLOCKED_DECISIONS_PAGE;
  readonly executableDetail = EXECUTABLE_DETAIL;
  readonly blockedDetail = BLOCKED_DETAIL;
  readonly disabledDetail = DISABLED_DETAIL;
  readonly formDetail = FORM_DETAIL;
  readonly lowConfidenceDetail = LOW_CONFIDENCE_DETAIL;
  readonly actionError: UxError = {
    title: "Action failed",
    message: "The ERP rejected the request because the vendor record is still locked."
  };
  readonly emptyDatesSummary = EMPTY_DATES_SUMMARY;
  readonly emptyActivityHistory: readonly SystemActivity[] = [];
  readonly emptyMetrics: readonly HomeMetric[] = [];

  constructor(
    public readonly lang: LanguageService,
    private readonly interactionState: HomeInteractionStateService
  ) {}

  get connectedState(): SseState {
    return "connected";
  }

  get connectingState(): SseState {
    return "connecting";
  }

  get errorState(): SseState {
    return "error";
  }

  get stateChangedMessage(): string {
    return this.lang.translate("home.decisionDetail.actionResult.stateChanged");
  }

  get reevaluationQueuedMessage(): string {
    return this.lang.translate("home.decisionDetail.actionResult.reevaluationQueued");
  }

  get inspectionOnlyMessage(): string {
    return this.lang.translate("home.decisionDetail.actionResult.inspectionOnly");
  }

  get businessAcknowledgedMessage(): string {
    return this.lang.translate("home.decisionDetail.actionResult.businessAcknowledged");
  }

  get manualCompletionMessage(): string {
    return this.lang.translate("home.decisionDetail.actionResult.manualBusinessCompletion");
  }

  get replayMessage(): string {
    return this.lang.translate("home.decisionDetail.actionResult.replay");
  }

  openDatesPanel(): void {
    this.interactionState.toggleDatesPanel(true);
  }

  openHistoryPanel(): void {
    this.interactionState.toggleHistoryPanel(true);
  }

  clearSelection(): void {
    this.interactionState.toggleDatesPanel(false);
    this.interactionState.toggleHistoryPanel(false);
    this.interactionState.setActivityDetail(null);
  }
}